import { createContext, type ReactNode, useCallback, useContext } from 'react';
import type { NavigateFunction } from './types';

interface NavigateProviderProps {
  children: ReactNode;
  navigate: NavigateFunction;
}

const NavigateContext = createContext<NavigateFunction | null>(null);

export function NavigateProvider({ children, navigate }: NavigateProviderProps): ReactNode {
  return <NavigateContext.Provider value={navigate}>{children}</NavigateContext.Provider>;
}

export function useNavigate() {
  const navigate = useContext(NavigateContext);

  if (navigate === null) {
    throw new Error('useNavigate must be used within a NavigateProvider');
  }

  return useCallback<NavigateFunction>(
    (to, options) => {
      navigate(to, options);
    },
    [navigate]
  );
}
